// File: src/components/AdminMediaList.jsx
import React, { useEffect, useState } from 'react';
import api from "../../api";

export default function MediaList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { fetchList(); }, []);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await api.get('/api/media');
      setItems(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const remove = async (id) => {
    const ok = window.confirm("Delete this media item?");
    if (!ok) return;
    try {
      await api.delete(`/api/media/${id}`);
      setItems(prev => prev.filter(i => i._id !== id));
    } catch (err) { console.error(err); }
  };

  const togglePublish = async (id, value) => {
    try {
      await api.put(`/api/media/${id}`, { published: value });
      setItems(prev => prev.map(i => i._id === id ? { ...i, published: value } : i));
    } catch (err) { console.error(err); }
  };

  return (
    <div className="max-w-7xl mx-auto p-4">

      {/* HEADER */}
      <div className="mb-7">
        <h2 className="text-3xl font-bold text-gray-800">Media Library</h2>
        <p className="text-gray-600 mt-1">Manage uploaded tracks, thumbnails, publish visibility and more.</p>
      </div>

      {/* TABLE */}
      {loading ? (
        <div className="text-center py-10 text-gray-600">Loading...</div>
      ) : (
        <div className="overflow-hidden rounded-xl shadow border border-gray-200 bg-white">

          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200 text-gray-700">
                <th className="p-3 text-left">Preview</th>
                <th className="p-3 text-left">Title</th>
                <th className="p-3 text-left">Artist</th>
                <th className="p-3 text-left">Size</th>
                <th className="p-3 text-left">Published</th>
                <th className="p-3 text-left">Actions</th>
              </tr>
            </thead>

            <tbody>
              {items.map(item => (
                <tr
                  key={item._id}
                  className="border-b hover:bg-gray-50 transition"
                >
                  {/* Thumbnail */}
                  <td className="p-3">
                    {item.coverUrl ? (
                      <img
                        src={item.coverUrl}
                        alt="thumb"
                        className="w-16 h-16 object-cover rounded shadow-sm"
                      />
                    ) : (
                      <div className="w-16 h-16 bg-gray-200 flex items-center justify-center rounded">
                        <span className="text-gray-400">N/A</span>
                      </div>
                    )}
                  </td>

                  {/* Title */}
                  <td className="p-3 font-medium text-gray-800">
                    {item.title}
                  </td>

                  {/* Artist */}
                  <td className="p-3 text-gray-600">
                    {item.artist || "—"}
                  </td>

                  {/* Size */}
                  <td className="p-3 text-gray-500">
                    {bytesToSize(item.size)}
                  </td>

                  {/* Published Toggle */}
                  <td className="p-3">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="hidden peer"
                        checked={item.published}
                        onChange={e => togglePublish(item._id, e.target.checked)}
                      />
                      <div className="w-11 h-6 bg-gray-300 peer-checked:bg-green-500 rounded-full relative transition-all">
                        <div className="h-5 w-5 bg-white rounded-full absolute top-0.5 left-0.5 peer-checked:translate-x-5 transition"></div>
                      </div>
                    </label>
                  </td>

                  {/* Actions */}
                  <td className="p-3">
                    <button
                      onClick={() => remove(item._id)}
                      className="px-3 py-1 bg-red-600 text-white rounded-md text-sm shadow hover:bg-red-700 transition"
                    >
                      Delete
                    </button>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

        </div>
      )}
    </div>
  );
}

function bytesToSize(bytes) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (!bytes) return '0 Bytes';
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
}
